import { render, staticRenderFns } from "./ProjectAccountingItemForm.vue?vue&type=template&id=65f14228"
import script from "./ProjectAccountingItemForm.vue?vue&type=script&lang=js"
export * from "./ProjectAccountingItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports